export const interpolators = [{label: 'Linear', key: "linear", value: 'linear'},
    {label: 'Ease In', key: 'easeIn', value: 'ease-in'},
    {label: 'Ease Out', key: 'easeOut', value: 'ease-out'},
    {label: 'Ease In Out', key: 'easeInOut', value: 'ease-in-out'},
    {label: 'Ease In Sine', key: 'easeInSine', value: 'cubic-bezier(0.12, 0, 0.39, 0)'},
    {label: 'Ease Out Sine', key: 'easeOutSine', value: 'cubic-bezier(0.61, 1, 0.88, 1)'},
    {label: 'Ease In Out Sine', key: 'easeInOutSine', value: 'cubic-bezier(0.37, 0, 0.63, 1)'},
    {label: 'Ease In Cubic', key: 'easeInCubic', value: 'cubic-bezier(0.32, 0, 0.67, 0)'},
    {label: 'Ease Out Cubic', key: 'easeOutCubic', value: 'cubic-bezier(0.33, 1, 0.68, 1)'},
    {label: 'Ease In Out Cubic', key: 'easeInOutCubic', value: 'cubic-bezier(0.65, 0, 0.35, 1)'},
    {label: 'Ease In Quad', key: 'easeInQuad', value: 'cubic-bezier(0.11, 0, 0.5, 0)'},
    {label: 'Ease Out Quad', key: 'easeOutQuad', value: 'cubic-bezier(0.5, 1, 0.89, 1)'},
    {label: 'Ease In Out Quad', key: 'easeInOutQuad', value: 'cubic-bezier(0.45, 0, 0.55, 1)'},
    {label: 'Ease In Quart', key: 'easeInQuart', value: 'cubic-bezier(0.5, 0, 0.75, 0)'},
    {label: 'Ease Out Quart', key: 'easeOutQuart', value: 'cubic-bezier(0.25, 1, 0.5, 1)'},
    {label: 'Ease In Out Quart', key: 'easeInOutQuart', value: 'cubic-bezier(0.76, 0, 0.24, 1)'},
    {label: 'Ease In Quint', key: 'easeInQuint', value: 'cubic-bezier(0.64, 0, 0.78, 0)'},
    {label: 'Ease Out Quint', key: 'easeOutQuint', value: 'cubic-bezier(0.22, 1, 0.36, 1)'},
    {label: 'Ease In Out Quint', key: 'easeInOutQuint', value: 'cubic-bezier(0.83, 0, 0.17, 1)'},
    {label: 'Ease In Expo', key: 'easeInExpo', value: 'cubic-bezier(0.7, 0, 0.84, 0)'},
    {label: 'Ease Out Expo', key: 'easeOutExpo', value: 'cubic-bezier(0.16, 1, 0.3, 1)'},
    {label: 'Ease In Out Expo', key: 'easeInOutExpo', value: 'cubic-bezier(0.87, 0, 0.13, 1)'},
    {label: 'Ease In Circ', key: 'easeInCirc', value: 'cubic-bezier(0.55, 0, 1, 0.45)'},
    {label: 'Ease Out Circ', key: 'easeOutCirc', value: 'cubic-bezier(0, 0.55, 0.45, 1)'},
    {label: 'Ease In Out Circ', key: 'easeInOutCirc', value: 'cubic-bezier(0.85, 0, 0.15, 1)'},
    {label: 'Ease In Back', key: 'easeInBack', value: 'cubic-bezier(0.36, 0, 0.66, -0.56)'},
    {label: 'Ease Out Back', key: 'easeOutBack', value: 'cubic-bezier(0.34, 1.56, 0.64, 1)'},
    {label: 'Ease In Out Back', key: 'easeInOutBack', value: 'cubic-bezier(0.68, -0.6, 0.32, 1.6)'},
    {
        label: 'Ease In Elastic',
        key: 'easeInElastic',
        value: 'linear(0 0%, 0.22 2.1%, 0.86 6.5%, 1.11 8.6%, 1.3 10.7%, 1.35 11.8%, 1.37 12.9%, 1.37 13.7%, 1.36 14.5%, 1.32 16.2%, 1.03 21.8%, 0.94 24%, 0.89 25.9%, 0.88 26.85%, 0.87 27.8%, 0.87 29.25%, 0.88 30.7%, 0.91 32.4%, 0.98 36.4%, 1.01 38.3%, 1.04 40.5%, 1.05 42.7%, 1.05 44.1%, 1.04 45.7%, 1 53.3%, 0.99 55.4%, 0.98 57.5%, 0.99 60.7%, 1 68.1%, 1.01 72.2%, 1 86.7%, 1 100%)'
    },
    {
        label: 'Ease In Bounce',
        key: 'easeInBounce',
        value: 'linear(0, 0.004, 0.016, 0.035, 0.063, 0.098, 0.141 13.6%, 0.25, 0.391, 0.563, 0.765, 1, 0.891 40.9%, 0.848, 0.813, 0.785, 0.766, 0.754, 0.75, 0.754, 0.766, 0.785,0.813, 0.848, 0.891 68.2%, 1 72.7%, 0.973, 0.953, 0.941, 0.938, 0.941, 0.953,0.973, 1, 0.988, 0.984, 0.988, 1)'
    }
]

export function selectedInterpolator(key?: string | null): { label: string, value: string, key: string } | undefined {
    return interpolators.find(interpolator => interpolator.key === key)
}